import cx from 'classnames'
import SectionStyles from 'components/Settings/Section.module.scss'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Heading } from 'blaze-ui/Heading/Heading'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import store from 'redux/store'
import { workspacesSet } from 'redux/actions'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { useWorkspace } from 'hooks/useWorkspace'

export const SnippetsSettings = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const workspaces = useWorkspaces()
  const workspace = useWorkspace(currentWorkspaceId)
  const snippetsEnabled = workspace?.snippets_enabled || false

  const toggleSnippets = async () => {
    const prevValue = snippetsEnabled

    store.dispatch(
      workspacesSet(
        workspaces.map((ws) => (ws.id === currentWorkspaceId ? { ...ws, snippets_enabled: !snippetsEnabled } : ws)),
      ),
    )
    const res = await WorkspaceClient.update(currentWorkspaceId, !snippetsEnabled)
    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      showToastMessage("We couldn't save your snippets settings.", 'error')
      store.dispatch(
        workspacesSet(
          workspaces.map((ws) => (ws.id === currentWorkspaceId ? { ...ws, snippets_enabled: prevValue } : ws)),
        ),
      )
    }
  }

  return (
    <>
      <div className={SectionStyles.sectionRow}>
        <div className={cx(SectionStyles.sectionFieldWrapper, SectionStyles.alignTop, SectionStyles.noPadding)}>
          <div className={SectionStyles.rowStyles}>
            <Heading level={5}>Snippets</Heading>
            <ToggleButton checked={!!snippetsEnabled} name="snippets" handleChange={toggleSnippets} />
          </div>
          <div className={cx(SectionStyles.sectionInput, SectionStyles.editing)}>
            <p className={SectionStyles.text}>
              Snippets are reusable information that you can apply during Blaze's AI content generation When enabled,
              snippets will appear in relevant fields throughout the product.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
